<p>view-notification-details works!</p>
